export enum TopoFileStatuses {
	STATUS_1 = '1',
	STATUS_2 = '2',
}
